import {createAction} from "@reduxjs/toolkit";

export const setCurrentEventPlaceId = createAction('SET_CURRENT_EVENT_PLACE_ID');